<template>
    <div class="container">
      <div class="info-container">
        <el-form size="small" :model="form" style="width: 87%;" ref="refForm" :rules="rules" label-width="180px">
          <el-form-item label-width="0" style="margin-bottom: 0;">
            <h4 style="color: #169BD5;">公司信息</h4>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="客户名称:" prop="customerName">
                <el-input
                  v-model.trim="form.customerName"
                  name="customerName"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人:" prop="contact">
                <el-input
                  v-model.trim="form.contact"
                  name="contact"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="contactPhone">
                <el-input
                  v-model.trim="form.contactPhone"
                  name="contactPhone"
                  type="tel"
                  autocomplete="on"
                  clearable
                  size="small">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址:" prop="contactAddr">
                <el-input
                  v-model.trim="form.contactAddr"
                  name="contactAddr"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="标签:" prop="labelType">
                <el-select
                  v-model.trim="form.labelType"
                  clearable
                  filterable
                  size="small">
                  <el-option
                    v-for="(item, i) in labelTypes"
                    v-if='item.val !== 14'
                    :key="i"
                    :label="item.chinese"
                    :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮件:" prop="contactEmail">
                <el-input
                  v-model.trim="form.contactEmail"
                  name="contactEmail"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="传真:" prop="contactFax">
                <el-input
                  v-model.trim="form.contactFax"
                  name="contactFax"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0" style="margin-bottom: 0;">
            <h4 style="color: #169BD5;">开票信息</h4>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="开票名称:" prop="invoiceName">
                <el-input
                  v-model.trim="form.invoiceName"
                  name="invoiceName"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纳税人识别号:" prop="taxpayerNo">
                <el-input
                  v-model.trim="form.taxpayerNo"
                  name="taxpayerNo"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="开户行:" prop="bankName">
                <el-input
                  v-model.trim="form.bankName"
                  name="bankName"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="16">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号:" prop="bankCardNo">
                <el-input
                  v-model.trim="form.bankCardNo"
                  name="bankCardNo"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="联系人:" prop="invoiceContact">
                <el-input
                  v-model.trim="form.invoiceContact"
                  name="invoiceContact"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="16">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="invoiceContactPhone">
                <el-input
                  v-model.trim="form.invoiceContactPhone"
                  name="invoiceContactPhone"
                  type="tel"
                  autocomplete="on"
                  clearable
                  size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0" style="margin-bottom: 0;">
            <h4 style="color: #169BD5;">收货信息</h4>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="联系人:" prop="receiver">
                <el-input
                  v-model.trim="form.receiver"
                  name="receiver"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="receiverPhone">
                <el-input
                  v-model.trim="form.receiverPhone"
                  name="receiverPhone"
                  type="tel"
                  autocomplete="on"
                  clearable
                  size="small"/>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0">
            <el-col :span="12">
              <el-form-item label="地址:" prop="receiverAddr">
                <el-input
                  v-model.trim="form.receiverAddr"
                  name="receiverAddr"
                  type="text"
                  autocomplete="on"
                  clearable
                  size="small"
                  maxlength="64">
                </el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label-width="0" class="bottom-container">
            <el-button :loading="loading" size="small" type="primary" @click="submitForm">{{$t('common.save')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { customersList, customersPost,customersPut } from '@/api/customers';
import {
  validateContactPhone,
} from '@/utils/validate';
import { isValueEmpty, isPositiveIntegerNum, isEmail } from '@/utils';
import { labelTypes } from '@/utils/defines';

const defaultForm = {
  customerName: undefined,
  companyLogo: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactFax: undefined,
  labelType: undefined,
  contactEmail: undefined,
  contactAddr: undefined,
  invoiceName: undefined,
  taxpayerNo: undefined,
  bankName: undefined,
  bankCardNo: undefined,
  invoiceContact: undefined,
  invoiceContactPhone: undefined,
  invoiceContactAddr: undefined,
  receiver: undefined,
  receiverPhone: undefined,
  receiverAddr: undefined,
};

export default {
  name: 'CustomerDetail',
  data() {
    let validatealertEmail = (rule, value, callback) => {
      if (isValueEmpty(value) || value === null) {
        callback();
        return;
      }
      if (!isEmail(value)) {
        callback(new Error('请输入正确的邮件'));
        return;
      }
      callback();
    };
    return {
      form: Object.assign({}, defaultForm),
      rules: {
        customerName: [{ required: true, trigger: 'blur', message: '客户名称不能为空'}],
        contact: [{ required: true, trigger: 'blur', message: '联系人不能为空'}],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone}],
        contactAddr: [{ required: true, trigger: 'blur', message: '地址不能为空'}],
        labelType: [{ required: true, trigger: 'blur', message: '标签不能为空'}],
        contactEmail: [{ trigger: 'blur', validator: validatealertEmail  }],
      },
      loading: false,
      tempRoute: {},
      labelTypes: labelTypes ,
    };
  },
  computed: {

  },
  mounted() {
    this.tempRoute = Object.assign({}, this.$route);
    this.prodStorageList();
  },
  methods: {
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.customersAction();
        }
      });
    },
    async prodStorageList() {
      if(!(this.$route.params && this.$route.params.id)){
      	return;
      }
      try {
        const res = await customersList({
          page: 1,
          perpage: 200,
        });
        for(let record of res.data.records) {
          if(this.$route.params.id == record.id){
            this.form.customerName = record.customerName;
            this.form.companyLogo = record.companyLogo;
            this.form.contact = record.contact;
            this.form.contactPhone = record.contactPhone;
            this.form.contactFax = record.contactFax;
            this.form.labelType = record.labelType;
            this.form.contactEmail = record.contactEmail;
            this.form.contactAddr = record.contactAddr;
            this.form.invoiceName = record.invoiceName;
            this.form.taxpayerNo = record.taxpayerNo;
            this.form.bankName = record.bankName;
            this.form.bankCardNo = record.bankCardNo;
            this.form.invoiceContact = record.invoiceContact;
            this.form.invoiceContactPhone = record.invoiceContactPhone;
            this.form.invoiceContactAddr = record.invoiceContactAddr;
            this.form.receiver = record.receiver;
            this.form.receiverPhone = record.receiverPhone;
            this.form.receiverAddr = record.receiverAddr;
            break;
          }
        }
      } catch (e) {
        // do nothing.
      }
    },
    async customersAction() {
        const {
            customerName,
            companyLogo,
            contact,
            contactPhone,
            contactFax,
            contactEmail,
            contactAddr,
            invoiceName,
            taxpayerNo,
            bankName,
            bankCardNo,
            invoiceContact,
            invoiceContactPhone,
            invoiceContactAddr,
            receiver,
            receiverPhone,
            receiverAddr,
            labelType,
        } = this.form;
        try {
            this.loading = true;
            if(!(this.$route.params && this.$route.params.id && parseInt(this.$route.params.id) !== 0)){
            	await customersPost({
            	    customerName: customerName || undefined,
            	    companyLogo: companyLogo || undefined,
            	    contact: contact || undefined,
            	    contactPhone: contactPhone || undefined,
            	    contactFax: contactFax || undefined,
            	    contactEmail: contactEmail || undefined,
            	    contactAddr: contactAddr || undefined,
            	    invoiceName: invoiceName || undefined,
            	    taxpayerNo: taxpayerNo || undefined,
            	    bankName: bankName || undefined,
            	    bankCardNo: bankCardNo || undefined,
            	    invoiceContact: invoiceContact || undefined,
            	    invoiceContactPhone: invoiceContactPhone || undefined,
            	    invoiceContactAddr: invoiceContactAddr || undefined,
            	    receiver: receiver || undefined,
            	    receiverPhone: receiverPhone || undefined,
            	    receiverAddr: receiverAddr || undefined,
            	    labelType: labelType || undefined,
            	});
            }else{
              await customersPut({
                  id: parseInt(this.$route.params.id),
                  customerName: customerName || undefined,
                  companyLogo: companyLogo || undefined,
                  contact: contact || undefined,
                  contactPhone: contactPhone || undefined,
                  contactFax: contactFax || undefined,
                  contactEmail: contactEmail || undefined,
                  contactAddr: contactAddr || undefined,
                  invoiceName: invoiceName || undefined,
                  taxpayerNo: taxpayerNo || undefined,
                  bankName: bankName || undefined,
                  bankCardNo: bankCardNo || undefined,
                  invoiceContact: invoiceContact || undefined,
                  invoiceContactPhone: invoiceContactPhone || undefined,
                  invoiceContactAddr: invoiceContactAddr || undefined,
                  receiver: receiver || undefined,
                  receiverPhone: receiverPhone || undefined,
                  receiverAddr: receiverAddr || undefined,
                  labelType: labelType || undefined,
              });
            }
            this.$message({
                type: 'success',
                message: '添加成功'
            });
            this.backOrderListPage();
        } catch (e) {
        } finally {
            this.loading = false;
        }
    },
    backOrderListPage() {
      this.$router.replace({ path: '/redirect/customers-page/list' });
      this.$store.dispatch('tagsView/delView', this.tempRoute);
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .title {
    margin: 10px 20px;
    font-size: 16px;
    color: #555555;
  }
  .info-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: center;
  }
  .bottom-container {
    text-align: center;
    margin: 20px 0;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .link.is-disabled {
    color: #C0C4CC;
  }
  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }
  .orange-button {
    background: #FF8605;
    color: white;
    border: 0;
  }
</style>
